<template>
	<div class="inner-page notification-log">
		<AppHead title="Notification Logs" />
		<PageHeader 
			title="Notification Logs"
			desc="See who receives specific notifications."
			:showHelper="true"
			helpTitle="Welcome to Notification Logs"
			helpDesc="Here you can inspect which notifications were sent and which users received them for each case."
			:hr="true"
			/>

		<div class="notification-filtering">
			<div class="filtering">
				<div class="filter">
					<div class="search-box">
						<input 
							type="text" 
							placeholder="Search by Case ID/Enquiry Number"
							v-model="filters.caseID"
							@keyup.enter="applyFilter"
							/>

						<div 
							v-if="filters.caseID != ''"
							class="clear-search" 
							@click="clearFilter"
							/>
					</div>
				</div>
				<div class="submit">
					<Button
						label="Filter"
						icon="fal fa-filter"
						color="blue"
						@click="applyFilter"
						/>
				</div>
			</div>
		</div>


		<TableNotifications 
			:notificationData="sentNotifications.data" 
			/>

		<PaginationLinks
			v-if="sentNotifications && sentNotifications.links"
			:links="sentNotifications.links"
			/>

	</div>
</template>

<script>
import AppHead from "@/Components/AppHead"
import AppLayout from "@/Layouts/AppLayout.vue"
import PageHeader from "@/Components/PageHeader"
import Button from '@/Components/Button'
import PaginationLinks from '@/Components/PaginationLinks'
import TableNotifications from '@/Components/TableNotifications'

export default {
	components: {
		AppHead,
		PageHeader,
		Button,
		PaginationLinks,
		TableNotifications
	},
	layout: AppLayout,
	title: 'Notification Logs',
	props: {
		sentNotifications: {
			type: [Object, Array, Boolean],
			default: false
		}
	},
	data: () => {
		return {
			filters: {
				caseID: ''
			}
		}
	},
	mounted(){
		// console.log('sentNotifications', this.sentNotifications)

		let urlParams = new URLSearchParams(window.location.search)
    if(urlParams.has('caseid')){
      this.filters.caseID = urlParams.get('caseid')
    }
	},
	methods: {
		clearFilter(){
			this.filters.caseID = ''
			this.applyFilter()
		},
		applyFilter(){
			let url = '/admin/notification-log'

			let arrayParams = []

			if(this.filters.caseID){
				// push to arrayparrams a url friendly version of the search string
				arrayParams.push(`caseid=${encodeURIComponent(this.filters.caseID)}`)
			}

			if(arrayParams.length > 0){
				url += `?${arrayParams.join('&')}`
			}

			this.$inertia.visit(url)
		},
	}
};
</script>

<style lang="sass">

.notification-log
	.table-notifications
		margin-bottom: 30px

	.notification-filtering
		width: 100%
		display: flex
		flex-direction: column
		gap: 20px
		margin-bottom: 30px

		.filtering
			width: 100%
			display: flex
			flex-direction: row
			gap: 10px
			align-items: flex-end

			.filter
				width: 100%
				display: flex
				flex-direction: column
				gap: 10px

				.label
					font-size: 16px
					font-weight: 700
					font-family: 'Roboto Condensed', sans-serif
					color: #252525
					line-height: 1.1

				.search-box
					width: 100%
					display: flex
					flex-direction: row
					gap: 10px
					position: relative

					input
						width: 100%
						padding: 12px 20px
						border-radius: 5px
						border: 1px solid #e5e5e5
						font-size: 16px
						font-weight: 400
						font-family: 'Roboto', sans-serif
						color: #252525
						line-height: 1.1
						appearance: none
						background-color: #fff
						transition: all 0.2s ease-in-out

					.clear-search
						position: absolute
						right: 0
						top: 0
						bottom: 0
						width: 40px
						display: flex
						align-items: center
						justify-content: center
						cursor: pointer

						&:before, &:after
							content: ''
							display: block
							width: 20px
							height: 2px
							background-color: #252525
							position: absolute
							transition: all 0.3s ease

						&:before
							transform: rotate(45deg)

						&:after
							transform: rotate(-45deg)

				.select
					width: 100%
					display: flex
					flex-direction: row
					gap: 10px

					select
						width: 100%
						padding: 12px 20px
						border-radius: 5px
						border: 1px solid #e5e5e5
						font-size: 16px
						font-weight: 400
						font-family: 'Roboto', sans-serif
						color: #252525
						line-height: 1.1
						appearance: none
						background-color: #fff
						transition: all 0.2s ease-in-out

			@media (max-width: 900px)
				flex-direction: column
				gap: 15px

				.filter
					width: 100%
					flex-direction: column
					gap: 0

					.label
						margin-bottom: 5px

					.select
						width: 100%
						flex-direction: column
						gap: 5px

						select
							padding: 15px 10px

</style>